import { configureStore } from '@reduxjs/toolkit'
import { timerSlice } from './timerSlice'
const store = configureStore({
    reducer: { timer: timerSlice.reducer }
})
export default store;
export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch